/**
 * Transport Service
 * Handles fetching the upcoming transports of the logged in user's active supplier
 */

import axios from 'axios';

/**
 * Fetches the upcoming transport legs for a user.
 *
 * The webservice resolves the active supplier from the user itself, keeps only
 * pickups from today onwards and returns them soonest first, so the caller does
 * not have to scope, filter or sort the result again.
 *
 * @param {string|number} uid - Drupal user ID of the logged in user
 * @returns {Promise<Array>} Array of transport legs, empty when there are none
 * @throws {Error} Throws Error('FORBIDDEN') on 403, rethrows other errors as-is
 */
export const fetchUpcomingTransports = async (uid) => {
  try {
    const response = await axios.get(`/transports/${uid}?_format=json`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (err) {
    if (err.response && err.response.status === 403) {
      throw new Error('FORBIDDEN');
    }
    throw err;
  }
};
